module.exports = __webpack_public_path__ + "img/logo_bgm.aff182dc.png";